import styled, { css } from 'styled-components';

import { getStyle } from 'modules/v2/editor/utils';

const Panel = styled.div`
  position: relative;
  border: 1px solid black;
  margin: 80px auto;
  zoom: 1.5;
  transform-origin: top;
  display: flex;
  flex-direction: column;

  ${({ layout }) => {
    const { width, height, marginTop, marginBottom, marginLeft, marginRight } = getStyle(layout);

    return css`
      width: ${width};
      min-height: ${height};
      padding-top: ${marginTop};
      padding-left: ${marginLeft};
      padding-right: ${marginRight};
      padding-bottom: ${marginBottom};
    `;
  }}
`;

const Wrapper = styled.div`
  .draftJsFocusPlugin__focused__3Mksn {
    border-radius: 0;
    box-shadow: none;
  }

  .infrnt > div > div > div {
    padding: 0;
  }

  .main .toolbar.tblfrnt {
    width: 100%;
    border-bottom: 1px solid #ced4f1;
    position: absolute;
    left: 0;
    background: #e6eff7;
    top: 0;
  }
  .textfield-wrapper {
    border: 1px dotted grey;
  }
  #title {
    border: none;
  }

  .textfield-wrapper a {
    color: #000;
    pointer-events: none;
  }

  div[class^='draftJsEmojiPlugin__alignmentTool'] {
    width: 110px !important;
    margin-top: -15px;
  }

  .EditorPanelCenter {
    position: relative;
    margin: 0;
  }

  img[class^='draftJsEmojiPlugin__image'] {
    margin: 15px 0;
    filter: grayscale(1);
  }

  img[class^='draftJsEmojiPlugin__image']:after {
    cursor: nesw-resize !important;
  }

  .public-DraftEditorPlaceholder-root {
    text-align: center;
    width: 100%;
  }

  .editorWrap {
    overflow: hidden;
  }

  .textfield-wrapper {
    overflow: hidden;

    ul {
      padding-inline-start: 25px;
    }

    .content-title,
    .title {
      margin: 0 !important;
    }
  }
`;

const Element = styled.div`
  ${({ showGuides, element }) => {
    const {
      order,
      margin,
      padding,
      lineHeight,
      fontFamily,
      fontSize,
      fontWeight,
      textAlign,
      color,
      border,
    } = getStyle(element);

    return css`
      color: ${color};
      order: ${order};
      font-size: ${fontSize};
      margin: ${margin};
      text-align: ${textAlign};
      line-height: ${lineHeight};
      font-family: ${fontFamily};
      font-weight: ${fontWeight};
      padding: ${padding};
      border: ${border};

      ${!showGuides &&
        `
          border-color: transparent;
        `}
    `;
  }}
`;

export default {
  Wrapper,
  Panel,
  Element,
};
